export const getSelectedRecentSearch = (data: any[], id: string) => {
    const selectedRecentSearch = data.find(item => (item.token === id));

    return selectedRecentSearch;
};
